// extracted by mini-css-extract-plugin
module.exports = {"list":"StartingGrid-module--list--1C7im","listItem":"StartingGrid-module--listItem--s7JWQ"};